module.exports = __webpack_public_path__ + "static/media/availability.94ed6c3c.svg";